/* Wubs – Måttbeställd priskonfigurator (NY modell 2026-08-11).
   Läser produktens EGNA varianter: vald variant (Tjocklek × Träslag × Kulör) sätter kr/enhet.
   Priset skickas ALDRIG från klienten: antal = mått-enhet (10 cm²-block / cm), variantpris = taxa/enhet.
   ATC = vald variant (qty = mått) + 0-kr Måttmarkör (qty = 1), samma _konfig_id → cart transform → 1 rad. */
(function () {
  var root = document.querySelector('[data-wubs-mk]');
  if (!root) return;

  var typ = root.dataset.typ || 'yta';
  var titel = root.dataset.titel || '';
  var dim1Label = root.dataset.dim1 || 'Längd';
  var dim2Label = root.dataset.dim2 || 'Bredd';
  var dim3Label = root.dataset.dim3 || 'Djup';
  var dimUnit = root.dataset.dimunit || 'cm';
  var enhet = parseFloat(root.dataset.enhet) || 10; // ytenhet i cm² per qty-block
  /* Fast grundpris per vara, i ÖRE. Ligger i produktens metafält custom.konfig_grundpris –
     samma källa som den stora konfiguratorn och ordervakten läser (docs/pris-och-kassa.md:
     priser hör inte hemma i temat). Tomt = 0 = exakt som förut. */
  var grundOre = Math.max(0, Math.round((parseFloat(root.dataset.grund) || 0) * 100));
  /* Startavgift per måttbeställning, i ÖRE. Tas ut EN gång per tillägg i korgen – aldrig per
     styck. Samma belopp och samma metafält som konfiguratorn använder. */
  var startOre = Math.max(0, Math.round((parseFloat(root.dataset.start) || 0) * 100));
  /* Skarvens pris i ÖRE (Tom 2026-10-26, långa ledstänger på produktsidan). Samma tilläggspost som
     3D-konfiguratorn läser – se SKARV PÅ PRODUKTSIDAN i wubs-matt-konfig.liquid. */
  var SKARV_ORE = Math.max(0, Math.round((parseFloat(root.dataset.skarvPris) || 0) * 100));
  // 'components' = nya modellen (tillägg i metaobjekt, priset via _components + Expand)
  // 'merge'      = gamla modellen (tillägg som varianter, en rad per tillägg + linesMerge)
  var mode = root.dataset.mode || 'merge';
  function lim(n) { var v = parseFloat(root.dataset[n]); return isFinite(v) ? v : null; }
  var LIMS = { d1: [lim('min1'), lim('max1')], d2: [lim('min2'), lim('max2')], d3: [lim('min3'), lim('max3')] };

  /* MÅTTAK PER VARIANT (2026-10-06). LIMS ovan är produktens ENDA tal för hela sidan. Materialet
     skiljer sig per variant, och snabbrutan släppte därför igenom mått materialet inte finns i:
     420 cm aluminiumledstång (max 270) och ett hyllplan i ek 16 mm på 460 × 60 (max 200 × 22) gick
     båda att lägga i korgen – uppmätt på live. Konfiguratorerna har alltid läst måtten per variant;
     nu gör den här rutan det också, ur samma metafält (se data-varlim i wubs-matt-konfig.liquid).
     Variantens tak vinner när det finns, annars gäller produktens precis som förut. */
  var VARLIM = {};
  try { VARLIM = JSON.parse(root.dataset.varlim || '{}') || {}; } catch (e) { VARLIM = {}; }
  /* …och måtten kan ligga på en ANNAN produkt: tröskeln och hyllplanet säljs från den
     konsoliderade kundprodukten, medan materialmåtten bor på konfiguratorns prisbärare
     (produktmetafältet custom.matt_master). Den kartan är därför nycklad på TRÄSLAGET (option 1),
     som är lika för alla ytbehandlingar av samma material. Variantens eget mått vinner, sedan
     träslagets, sist produktens matt_max*. */
  var VARLIM_TRA = {};
  try { VARLIM_TRA = JSON.parse(root.dataset.varlimTra || '{}') || {}; } catch (e) { VARLIM_TRA = {}; }
  function limsFor(v) {
    var par = (v && VARLIM[String(v.id)]) || null;
    if (!par && v) {
      var tra = String(v.option1 || (v.options && v.options[0]) || '').toLowerCase().trim();
      if (tra) par = VARLIM_TRA[tra] || null;
    }
    if (!par) return { d1: LIMS.d1, d2: LIMS.d2, d3: LIMS.d3, skarv: 0 };
    function tak(i, fallback) {
      var n = parseFloat(par[i]);
      return (isFinite(n) && n > 0) ? n : fallback;
    }
    return {
      d1: [LIMS.d1[0], tak(0, LIMS.d1[1])],
      d2: [LIMS.d2[0], tak(1, LIMS.d2[1])],
      d3: LIMS.d3,
      skarv: tak(2, 0)   // skarvtaket (custom.skarv_max), 0 = finns inget
    };
  }

  var variants = [];
  try { variants = JSON.parse(root.dataset.variants || '[]'); } catch (e) { variants = []; }
  var byId = {};
  variants.forEach(function (v) { byId[String(v.id)] = v; });

  var vidInput = root.querySelector('[data-pdp-variant-id]');
  var langdI = root.querySelector('[data-mk-langd]');
  var breddI = root.querySelector('[data-mk-bredd]');
  var priceEl = root.querySelector('[data-mk-price]');
  var ordEl = root.querySelector('[data-mk-ord]');
  // Kampanjprocenten från Liquid. BARA visningen – korgen får ordinarie pris, Shopify drar rabatten.
  var kampanjPct = Number(root.getAttribute('data-kampanj-pct')) || 0;
  if (!(kampanjPct > 0 && kampanjPct < 100)) kampanjPct = 0;
  var perUnitEl = root.querySelector('[data-mk-perunit]');
  /* FRÅN-PRIS (2026-10-29) – räknat i Liquid (snippets/wubs-fran-pris.liquid), samma tal som JSON-LD.
     Visas bara medan konfigurationen är ofullständig; saknas attributet är allt som förut ("0 kr"). */
  var franOre = Number(root.getAttribute('data-fran-ore')) || 0;
  var franOrdOre = Number(root.getAttribute('data-fran-ord-ore')) || 0;
  // Från-pris per variant (variant-id → [öre, ordinarie öre, text]) – samma tal som Shopping-flödet.
  var franKarta = {}, forstaVariantId = null;
  try { var fkEl = root.querySelector('[data-mk-fran-karta]'); if (fkEl) franKarta = JSON.parse(fkEl.textContent) || {}; } catch (e) { franKarta = {}; }
  var franText = root.getAttribute('data-fran-text') || '';
  var noteEl = root.querySelector('[data-mk-note]');
  var justerat = {};
  function fmtMatt(v) { return String(v).replace('.', ','); }
  var atc = root.querySelector('[data-mk-atc]');
  var ncsField = root.querySelector('[data-mk-ncs-field]');
  var ncsInput = root.querySelector('[data-mk-ncs]');
  var qtyInput = root.querySelector('[data-mk-qty]');
  var djupI = root.querySelector('[data-mk-djup]'); // 3:e måttet (elementskydd: Djup/gavlar)
  var addonSels = [].slice.call(root.querySelectorAll('[data-mk-addon]')); // 1+ platta tilläggsaxlar (fast pris/stycke)
  var addonMatt = [].slice.call(root.querySelectorAll('[data-mk-addon-matt]')); // mätbara tillägg (pris = taxa × mått)

  var HARD_MAX_QTY = 1990; // under Shopifys 2000-komponentgräns för linesMerge

  function num(el) {
    if (!el) return 0;
    var v = parseFloat(String(el.value || '').replace(',', '.'));
    return isFinite(v) && v > 0 ? v : 0;
  }
  function fmtKr(cents) { return Math.round(cents / 100).toLocaleString('sv-SE') + ' kr'; }
  // Taxa/enhet: yta → kr/dm² (variantpris är öre/enhet-cm² → öre/dm² = cents × 100/enhet → kr = /100), linjär → kr/löpmeter (öre/cm)
  function fmtRate(cents) {
    if (typ === 'yta' || typ === 'elementskydd') return (cents / enhet).toLocaleString('sv-SE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' kr/dm²';
    return Math.round(cents).toLocaleString('sv-SE') + ' kr/löpmeter';
  }
  // Alla tilläggsaxlar. TVÅ sorter:
  //  a) VAL (rullista)  → egen rad med antal 1, pris = variantens pris
  //  b) MÅTT (talfält)  → egen rad med antal = det inmatade måttet, pris = taxa × måttet
  // (b) finns för att ett tillägg som prissätts PER ENHET (trappräckets höjd: 25,60 kr/cm)
  // annars hade krävt en variant per steg – 21 varianter för 90–110 cm. Nu räcker EN.
  // Båda returnerar 'flat' = kronor som ska läggas på priset, så prisräkningen är gemensam.
  function addonsData() {
    var out = addonSels.map(function (sel) {
      var o = sel.options[sel.selectedIndex];
      var grupp = sel.dataset.addonlabel || 'Tillägg';
      var etikett = o.textContent.replace(/\s*\(\+.*\)$/, '').trim();

      /* 🧨 DOLT FÄLT ⇒ DOLD RADEGENSKAP (2026-10-05, efter #6601).
         Grupper med `typ=alltid` eller ett enda alternativ renderas `hidden` – kunden gör
         inget val. Men egenskapen skrevs ändå ut synligt med gruppen som nyckel och postens
         etikett som värde, så orderbekräftelsen visade val som aldrig gjorts, ofta med sig
         själva som värde: "Skarv: Skarv", "Grundavgift: Grundavgift", och rena kalkyletiketter
         som "NCS: Egen NCS-kulör – engångskostnad".
         ⚠️ Egenskapen får INTE bara tas bort: prisvakten slår upp `props[gruppnamn]` och
            hoppar över gruppen när den saknas – då blir det förväntade priset upp till
            1 416 kr för lågt och VARJE order larmar. Samma fälla som `_Startavgift`.
         Två fall:
           alltid  → ren kostnadspost, inget kunden "har". Nyckeln blir `_tillagg:<grupp>`,
                     dold för kunden men läsbar för vakten (se synligaProps + prisvakt.js).
           enval   → en riktig produktegenskap som råkar sakna alternativ (Urtag, Avrundning).
                     Står kvar synlig men som "Ja" i stället för kalkyletiketten. Vakten har
                     sedan tidigare en 'Ja'-gren som prissätter gruppens enda post. */
      var alltid = sel.dataset.addontyp === 'alltid';
      var dolt = sel.dataset.dolt === '1';
      return {
        id: parseInt(o.value, 10) || 0,   // 0 i metaobjekt-modellen (posterna har inget variant-id)
        flat: parseInt(o.dataset.price, 10) || 0,
        qty: 1,
        label: alltid ? etikett : (dolt ? 'Ja' : etikett),
        key: alltid ? ('_tillagg:' + grupp) : grupp
      };
    });
    addonMatt.forEach(function (el) {
      var rate = parseInt(el.dataset.price, 10) || 0;
      var mn = el.dataset.min != null ? parseFloat(el.dataset.min) : null;
      var mx = el.dataset.max != null ? parseFloat(el.dataset.max) : null;
      var enh = el.dataset.enhet || '';
      var val = num(el);
      var bad = '';   // låser ATC
      var info = '';  // bara upplysning – värdet är giltigt
      // Samma regler som för måtten: max klampas hårt (fabriksgräns, skrivs tillbaka och är
      // därefter GILTIGT), min låser ATC utan att skriva över det användaren håller på att skriva.
      if (mx != null && val > mx) { val = mx; el.value = mx; info = 'Max ' + el.dataset.addonlabel + ' ' + mx + ' ' + enh + '.'; }
      if (val <= 0) bad = 'Ange ' + el.dataset.addonlabel + '.';
      else if (mn != null && val < mn) bad = 'Min ' + el.dataset.addonlabel + ' ' + mn + ' ' + enh + '.';
      out.push({
        id: parseInt(el.dataset.variant, 10) || 0,
        flat: Math.round(rate * val),
        qty: Math.round(val),
        matt: true,
        ogiltig: bad,
        notis: info,
        label: val > 0 ? (val + ' ' + enh) : '',
        key: el.dataset.addonlabel || 'Tillägg'
      });
    });
    return out;
  }

  function curVariant() {
    var id = vidInput ? String(vidInput.value || '') : '';
    return byId[id] || byId[String(variants[0] && variants[0].id)] || null;
  }
  // "Egen NCS/kulör/färg" upptäcks på variantens options
  function isEgenVariant(v) {
    if (!v) return false;
    var opts = v.options || [v.option1, v.option2, v.option3];
    for (var i = 0; i < opts.length; i++) {
      var o = String(opts[i] || '').toLowerCase();
      if (o.indexOf('egen ncs') > -1 || o.indexOf('egen kulör') > -1 || o.indexOf('egen färg') > -1 || o.indexOf('egen') > -1) return true;
    }
    return false;
  }

  function state() {
    var v = curVariant();
    var price = v ? (parseInt(v.price, 10) || 0) : 0;
    var isEgen = isEgenVariant(v);
    var ncs = ncsInput ? String(ncsInput.value || '').trim() : '';
    var orderQty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
    if (orderQty < 1) orderQty = 1;

    var msg = '';
    var belowMin = false;
    // Klampar mått till produktens min/max. Max = hårt (skriver tillbaka, fabriksgräns);
    // min = mjuk (visar meddelande + låser ATC tills giltigt), skriver ej tillbaka under skrivning.
    function dim(el, active, lims, lbl) {
      if (!active || !el) return 0;
      var v = num(el);
      /* Beskedet blinkade förbi: "Max Djup 17 cm." försvann vid nästa render, medan fältet stod kvar på 17
         (Tom 2026-11-02). Nu ligger det kvar tills fältet ändras eller taket flyttas. */
      if (lims[1] != null && v > lims[1]) { justerat[lbl] = { fran: v, till: Number(lims[1]) }; v = lims[1]; el.value = lims[1]; }
      var j = justerat[lbl];
      if (j && (Number(v) !== j.till || Number(lims[1]) !== j.till)) { delete justerat[lbl]; j = null; }
      if (j) msg += 'Största ' + lbl.toLowerCase() + ' här är ' + fmtMatt(j.till) + ' ' + dimUnit + ', så vi räknar på det i stället för ' + fmtMatt(j.fran) + ' ' + dimUnit + '. ';
      if (lims[0] != null && v > 0 && v < lims[0]) { belowMin = true; msg += 'Min ' + lbl + ' ' + lims[0] + ' ' + dimUnit + '. '; }
      return v;
    }
    var is3d = typ === 'elementskydd';
    /* Taket läses för den VALDA varianten, inte för produkten – och eftersom render() körs om på
       wubs:variant:change klampas ett redan skrivet mått ner när kunden byter till ett smalare
       material (420 cm ek → aluminium ger 270 och notisen "Max Längd 270 cm"). */
    var L = limsFor(v);
    /* SKARV (Tom 2026-10-26). En ledstång längre än varianten görs i ett stycke skarvas – samma regel
       och samma tak som 3D-konfiguratorn: `kanSkarvas()` kräver skarvtak > maxlängd (aluminium har
       270/270 och går inte att skarva). Då höjs längdens tak till skarvtaket, och en längd över
       maxlängden blir skarvad: skarvpriset läggs i styckpriset och raden bär `Skarv: Ja` – exakt
       den egenskap konfiguratorn skriver och ordervakten prissätter (gruppens enda post × 1).
       Ingen ja/nej-fråga som i konfiguratorn: kunden har redan skrivit längden, och raden ovanför
       priset säger att den skarvas och vad det kostar innan något läggs i korgen.
       ⚠️ Bara i _components-modellen – den gamla merge-modellen har ingen väg för skarvpriset.
       ⚠️ EN skarv per stång, som i konfiguratorn (den tar också betalt en gång per stång). */
    var linjar = typ !== 'yta' && typ !== 'elementskydd';
    var ettStycke = L.d1[1];
    var kanSkarva = mode === 'components' && linjar && ettStycke != null && L.skarv > ettStycke;
    var langd = dim(langdI, true, kanSkarva ? [L.d1[0], L.skarv] : L.d1, dim1Label);
    var skarvad = kanSkarva && langd > ettStycke;
    var bredd = dim(breddI, (typ === 'yta' || is3d), L.d2, dim2Label);
    var djup = dim(djupI, is3d, L.d3, dim3Label);

    var qty, area;
    if (typ === 'yta') { area = langd * bredd; qty = Math.round(area / enhet); }              // L×B
    else if (is3d) { area = bredd * (langd + djup); qty = Math.round(area / enhet); }          // Höjd×(Bredd+Djup)
    else { area = 0; qty = Math.ceil(langd); }                                                 // linjär: cm
    // 3D kräver alla tre mått; annars räcker de synliga
    if (is3d && (langd <= 0 || bredd <= 0 || djup <= 0)) qty = 0;
    if (belowMin) qty = 0; // under minsta mått → lås ATC tills giltigt
    /* 🧨 ÖVER KOMPONENTTAKET: BLOCKERA, KLAMPA INTE (2026-10-06). Kvantiteten ÄR måttet, så ett
       tak på 1990 enheter betyder tak på ~199 dm² yta. Den gamla raden klampade qty och lät köpet
       gå igenom – till priset för 199 dm². Uppmätt på live: ett hyllplan i furu 460 × 61 (280,6 dm²)
       kostade 5 573 kr i stället för ~7 776 kr, alltså 2 203 kr för lite, och enda spåret var
       notisen "Maxstorlek nådd". Ett fel pris är värre än ett uteblivet köp: nu låses köpknappen
       och kunden hänvisas vidare (konfiguratorn prissätter per hylla och har inget sådant tak). */
    if (qty > HARD_MAX_QTY) { qty = 0; msg += 'Måttet är för stort för att beställas här – använd konfiguratorn eller kontakta oss. '; }

    var addons = addonsData();
    var addonFlat = addons.reduce(function (sum, a) { return sum + a.flat; }, 0);
    if (skarvad) {
      addonFlat += SKARV_ORE;
      msg += 'Över ' + ettStycke + ' ' + dimUnit + ' skarvas ledstången' + (SKARV_ORE ? ' (+' + fmtKr(SKARV_ORE) + ')' : '') + '. ';
    }
    // Ett mätbart tillägg utan giltigt värde låser ATC på samma sätt som ett mått under min.
    // Klampnotiser (max nådd) visas men låser inte – värdet är giltigt efter klampningen.
    var addonFel = addons.filter(function (a) { return a.ogiltig; }).map(function (a) { return a.ogiltig; });
    var addonNotis = addons.filter(function (a) { return a.notis; }).map(function (a) { return a.notis; });
    if (addonNotis.length) msg += addonNotis.join(' ') + ' ';
    if (addonFel.length) msg += addonFel.join(' ') + ' ';

    return {
      variant: v, price: price, isEgen: isEgen, ncs: ncs, orderQty: orderQty,
      langd: langd, bredd: bredd, djup: djup, is3d: is3d, area: area, qty: qty, msg: msg.trim(),
      addons: addons, addonFlat: addonFlat, addonOk: addonFel.length === 0, skarvad: skarvad
    };
  }

  /* ÄNDKNOPPAR I EK PASSAR INTE TILL EN LÄDERLINDAD STÅNG (Tom 2026-10-08).
     Samma regel som 3D-konfiguratorns `endAllowedForWood`, samma fält: metaobjektets
     `galler_traslag`, utskrivet som `data-traslag` på varje <option>. Tomt = gäller alla.
     ⚠️ Matchar mot ALLA variantens optionsvärden, inte mot option1. `ledstang` har Profil på
        axel 1 och Träslag på axel 2 sedan profilaxeln tillkom – en hårdkodad axel hade gett
        "Rund" som träslag. (Samma antagande finns kvar på rad ~47 i den här filen, där
        måttkartan nycklas på option1; det biter inte i dag eftersom ledstang saknar matt_master.)
     ⚠️ BÅDE `hidden` OCH `disabled`: Safari har historiskt struntat i `hidden` på <option>,
        medan `disabled` håller den utanför valet överallt.
     ⚠️ Blir INGET alternativ giltigt lämnas valet orört – hellre ett tveksamt alternativ än en
        tom rullista som inte går att lägga i korgen. */
  function tillattForVariant(opt, v) {
    var lista = String(opt.getAttribute('data-traslag') || '').trim();
    if (!lista) return true;
    var opts = (v && (v.options || [v.option1, v.option2, v.option3])) || [];
    var valda = opts.map(function (x) { return String(x || '').toLowerCase().trim(); });
    return lista.split(',').some(function (w) {
      return valda.indexOf(w.toLowerCase().trim()) > -1;
    });
  }

  function filtreraTillagg() {
    var v = curVariant();
    addonSels.forEach(function (sel) {
      var forsta = null, valdOk = false;
      [].slice.call(sel.options).forEach(function (o) {
        var ok = tillattForVariant(o, v);
        o.hidden = !ok;
        o.disabled = !ok;
        if (ok) {
          if (!forsta) forsta = o;
          if (o.selected) valdOk = true;
        }
      });
      /* Står kunden kvar på ett alternativ som inte längre gäller faller valet till det första
         giltiga – annars hade priset räknats på en ände varianten inte kan få. Att sätta
         `selected` utlöser inget change-event, så ingen loop uppstår. */
      if (!valdOk && forsta) forsta.selected = true;
      // Egen rullista (wubs-dd.js): valet ovan byts utan händelse – knappens text måste följa med.
      if (window.WubsDD) window.WubsDD.synka(sel);
    });
  }

  function render() {
    filtreraTillagg();
    var s = state();
    if (ncsField) ncsField.hidden = !s.isEgen;

    var ok = !!s.variant && s.qty > 0 && s.addonOk && (!s.isEgen || s.ncs.length > 0);
    atc.disabled = !ok;

    // Priset visas FÖRST när konfigurationen är komplett – samma villkor som köpknappen.
    // Annars räknades platta tillägg (baskostnad/grundavgift/stolpar) in medan måtten var
    // tomma, så en orörd konfigurator kunde visa t.ex. "2 001 kr" som såg ut som ett totalpris.
    var perPiece = ok ? (s.qty * s.price + s.addonFlat + grundOre) : 0;
    /* Startavgiften läggs till EN gång på totalen, inte på styckpriset: tre trösklar ska bära
       den en gång. Priset kunden ser är därför summan, precis som i konfiguratorn. */
    var ordinarieOre = s.orderQty * perPiece + (ok ? startOre : 0);
    /* Utan ?variant= visar sidan den BILLIGASTE varianten (samma som JSON-LD för basadressen) tills
       kunden byter variant – annars hade förvalet (t.ex. ek) ersatt "Från 1 105 kr" vid sidladdning. */
    if (s.variant && forstaVariantId === null) forstaVariantId = String(s.variant.id);
    /* Serverns svar, inte adressen: variantväljaren skriver ?variant= redan vid sidladdning, så adressen sa
       alltid ja och basadressen visade 1 360 kr medan JSON-LD och flödet sa 1 105 (2026-11-03). */
    var fvAktiv = s.variant && (!!root.dataset.valdVariant || String(s.variant.id) !== forstaVariantId);
    var fv = fvAktiv && franKarta[String(s.variant.id)];
    var fOre = fv ? fv[0] : franOre, fOrdOre = fv ? fv[1] : franOrdOre, fText = fv ? fv[2] : franText;
    if (!ok && fOre) {
      priceEl.textContent = 'Från ' + fmtKr(fOre);
      if (ordEl) ordEl.textContent = fOrdOre ? fmtKr(fOrdOre) : '';
    } else {
      priceEl.textContent = fmtKr(kampanjPct ? Math.floor(ordinarieOre * (100 - kampanjPct) / 100) : ordinarieOre);
      if (ordEl) ordEl.textContent = ok && kampanjPct ? fmtKr(ordinarieOre) : '';
    }
    // Taxan följer kampanjen – annars stod "1 300 kr/löpmeter" bredvid "Från 1 105 kr" och en överstruken 1 300 (Liam 2026-10-29).
    if (perUnitEl) perUnitEl.textContent = s.price ? fmtRate(kampanjPct ? s.price * (100 - kampanjPct) / 100 : s.price) : '';

    if (noteEl) {
      var parts = [];
      if (s.msg) parts.push(s.msg);
      if (s.qty > 0) {
        if (typ === 'yta' || s.is3d) parts.push('Yta ≈ ' + (s.area / 100).toLocaleString('sv-SE', { minimumFractionDigits: 1, maximumFractionDigits: 1 }) + ' dm²');
        else parts.push(s.langd + ' ' + dimUnit);
        if (s.orderQty > 1) parts.push('× ' + s.orderQty + ' st');
      } else if (fOre && fText) {
        parts.push(fText + ' · Ange mått för exakt pris');
      } else {
        parts.push('Ange mått för pris');
      }
      if (s.isEgen && !s.ncs) parts.push('Ange NCS-kod');
      noteEl.textContent = parts.join(' · ');
      noteEl.classList.toggle('is-justerat', Object.keys(justerat).length > 0);
    }
    return s;
  }

  function konfigId() { return 'mk-' + Date.now().toString(36) + '-' + Math.floor(Math.random() * 1e7).toString(36); }

  function addToCart() {
    var s = render();
    if (atc.disabled || !s.variant) return;
    var vid = parseInt(s.variant.id, 10);
    var items = [];

    // Ett måttbeställt stycke = en egen _konfig_id-grupp (EN komponentrad: vald variant, qty = mått).
    // Cart-transformen slår ihop gruppen till en rad och visar "1 st" även för en enda komponent
    // (verifierat), så ingen extra markör-rad behövs. orderQty stycken = orderQty grupper.
    // ---- NYA MODELLEN: EN rad, priset i _components (Expand-blocket sätter det) ----
    if (mode === 'components') {
      var perPiece = s.qty * s.price + s.addonFlat + grundOre;      // öre per stycke
      var props = { '_konfig_titel': titel };
      props[dim1Label + ' (' + dimUnit + ')'] = String(s.langd);
      if (typ === 'yta') { props[dim2Label + ' (' + dimUnit + ')'] = String(s.bredd); props['Yta (dm²)'] = (s.area / 100).toFixed(1); }
      if (s.is3d) { props[dim2Label + ' (' + dimUnit + ')'] = String(s.bredd); props[dim3Label + ' (' + dimUnit + ')'] = String(s.djup); props['Yta (dm²)'] = (s.area / 100).toFixed(1); }
      s.addons.forEach(function (a) { if (a.label) props[a.key] = a.label; });
      // Synlig – som konfiguratorns rad. Följer med ner i komponenten (synligaProps) så den står på papperet.
      if (s.skarvad) props['Skarv'] = 'Ja';
      if (s.isEgen && s.ncs) props['NCS-kod'] = s.ncs;
      if (grundOre > 0) props['_Grundavgift'] = fmtKr(grundOre) + ' (ingår i raden)';
      // ⚠️ id MÅSTE vara en STRÄNG – med ett tal expanderar funktionen inte, helt tyst.
      /* ⚠️⚠️ SPECEN MÅSTE MED NER I `_components`, annars finns den inte på papperet.
         Cart-transformens Expand gör raden till en BUNT: kundens radegenskaper hamnar på
         line item-GRUPPEN, och komponentraden – den enda `order.line_items` innehåller, och
         alltså den enda Order Printer kan loopa – blir tom. Uppmätt på order #6594
         (2026-10-05): två måttbeställda fönsterbänkar, 117,7×11 och 80×15 cm, och BÅDA
         pappren skrev "Fönsterbänk · 18 mm Furu / Obehandlad · 2 st" utan ett enda mått.
         Verkstaden hade kapat två likadana skivor i okänd storlek.
         Function Studios `_components` tar ett `properties`-objekt per komponent som appen
         skriver ut som radegenskaper på den expanderade raden (deras dokumentation,
         function-studio.app/docs/cart-expand). Samma spec skickas därför två gånger: som
         radegenskap (korgen, kundens vy, admin) och i komponenten (ordern, papperet).
         ⚠️ Bara SYNLIGA nycklar. `_`-prefix är Shopifys konvention för dolda egenskaper, och
            `_components` i sig självt får så klart aldrig med sig sin egen kopia. */
      function synligaProps(p) {
        var ut = {};
        Object.keys(p).forEach(function (k) {
          /* ⚠️ MÅSTE FÖLJA MED NER I KOMPONENTEN. Prisvakten läser den EXPANDERADE
             komponentraden – den enda `order.line_items` innehåller – och utan den här
             markören räknar den fram ett pris UTAN startavgiften och larmar falskt på
             varje order som bär den. `_`-prefixet gör den osynlig för kunden. */
          if (k === '_Startavgift' || k.indexOf('_tillagg:') === 0) { ut[k] = String(p[k]); return; }
          if (k.charAt(0) === '_') return;
          var v = p[k];
          if (v === null || v === undefined || String(v) === '') return;
          ut[k] = String(v);
        });
        return ut;
      }
      function komponent(ore, p) {
        return JSON.stringify([{ id: String(vid), price: (ore / 100).toFixed(2), qty: 1, properties: synligaProps(p) }]);
      }
      /* ⚠️⚠️ STARTAVGIFTEN FÅR INTE LIGGA I STYCKPRISET. `_components`-priset multipliceras med
         radens antal, så 3 st hade burit avgiften tre gånger. Raden delas därför i 1 st med
         avgiften + resten utan – exakt samma mekanik som konfiguratorernas NCS-tillägg.
         Egenskapen "Startavgift" är också ordervaktens flagga för vilken rad den ligger på. */
      if (startOre > 0) {
        var medAvgift = {};
        Object.keys(props).forEach(function (k) { medAvgift[k] = props[k]; });
        medAvgift['_Startavgift'] = fmtKr(startOre) + ' (en gång per beställning, ingår i raden)';
        medAvgift['_components'] = komponent(perPiece + startOre, medAvgift);
        items.push({ id: vid, quantity: 1, properties: medAvgift });
        if (s.orderQty > 1) {
          props['_components'] = komponent(perPiece, props);
          items.push({ id: vid, quantity: s.orderQty - 1, properties: props });
        }
      } else {
        props['_components'] = komponent(perPiece, props);
        items.push({ id: vid, quantity: s.orderQty, properties: props });
      }
      send(items);
      return;
    }

    for (var n = 0; n < s.orderQty; n++) {
      var kid = konfigId();
      var p = { '_konfig_grupp': 'matt', '_konfig_id': kid, '_konfig_parent': String(vid), '_konfig_titel': titel };
      p[dim1Label + ' (' + dimUnit + ')'] = String(s.langd);
      if (typ === 'yta') { p[dim2Label + ' (' + dimUnit + ')'] = String(s.bredd); p['Yta (dm²)'] = (s.area / 100).toFixed(1); }
      if (s.is3d) { p[dim2Label + ' (' + dimUnit + ')'] = String(s.bredd); p[dim3Label + ' (' + dimUnit + ')'] = String(s.djup); p['Yta (dm²)'] = (s.area / 100).toFixed(1); }
      // Synliga val från tilläggsaxlarna på huvudraden (t.ex. Höjd / Första stolpe / Färg)
      s.addons.forEach(function (a) { if (a.id && a.label) p[a.key] = a.label; });
      if (s.isEgen && s.ncs) p['NCS-kod'] = s.ncs;
      items.push({ id: vid, quantity: s.qty, properties: p });

      // Platta tilläggsrader (baskostnad/avrundning/stolpar/färg), qty 1, samma _konfig_id → mergas in
      s.addons.forEach(function (a) {
        // Mätbara tillägg bär sitt mått som antal (pris = variantens taxa × antal, serverräknat);
        // vanliga val är alltid 1. Priset lämnar aldrig klienten – bara variant-id och antal.
        if (a.id) items.push({ id: a.id, quantity: a.qty || 1, properties: { '_konfig_grupp': 'matt', '_konfig_id': kid, '_konfig_parent': String(vid), 'Hör till': titel } });
      });
    }

    send(items);
  }

  var skickar = false;   // dubbeltryck på mobilen la måttbeställningen i korgen två gånger
  function send(items) {
    if (skickar) return;
    skickar = true;
    var drawer = document.querySelector('wubs-cart-drawer');
    if (drawer && typeof drawer.cartRequest === 'function') {
      drawer.rensaKopFel(atc);
      drawer.cartRequest('cart/add.js', { items: items }).then(function () {
        skickar = false;
        if (typeof drawer.open === 'function') drawer.open();
      }, function () {
        // Korgen sa nej eller nätet är borta (2026-11-03): besked vid knappen, ingen låda utan varan.
        skickar = false;
        drawer.visaKopFel(atc);
      });
    } else {
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function () { window.location = '/cart'; });
    }
  }

  // Vald variant kommer från produktens egen variantväljare (wubs-product.js)
  document.addEventListener('wubs:variant:change', function (e) {
    if (e.detail && e.detail.variantId && vidInput) vidInput.value = e.detail.variantId;
    render();
  });

  if (langdI) langdI.addEventListener('input', render);
  if (breddI) breddI.addEventListener('input', render);
  if (djupI) djupI.addEventListener('input', render);
  addonSels.forEach(function (sel) { sel.addEventListener('change', render); });
  addonMatt.forEach(function (el) { el.addEventListener('input', render); });
  if (ncsInput) ncsInput.addEventListener('input', render);
  if (qtyInput) {
    qtyInput.addEventListener('input', render);
    var qDec = root.querySelector('[data-mk-qty-dec]');
    var qInc = root.querySelector('[data-mk-qty-inc]');
    if (qDec) qDec.addEventListener('click', function () { qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1); render(); });
    if (qInc) qInc.addEventListener('click', function () { qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1; render(); });
  }
  atc.addEventListener('click', addToCart);
  render();
})();
